import { createContext, useContext } from 'react';

import type { NavigationContextValue } from '@/app/navigation-context/types.js';

export const NavigationContext = createContext<NavigationContextValue | null>(null);

export function useNavigationContext(): NavigationContextValue {
  const value = useContext(NavigationContext);

  if (!value) {
    throw new Error('useNavigationContext must be used within NavigationContextProvider');
  }

  return value;
}

export function useOptionalNavigationContext(): NavigationContextValue | null {
  return useContext(NavigationContext);
}
